import fetchData from './fetchData';
import config from './apiConfig';

export default (token, id) =>
    new Promise((resolve, reject) => {
  const options = {
            ...config.deleteCorporateOfficeContract,
            url: `${config.deleteCorporateOfficeContract.url}/${token}/CorporateOfficeContract/${id}`,
  };
        return fetchData(options)
    .then((data) => {
                if (data && !data.ErrorCode) {
                    resolve(data);
      } else {
                    reject({ fetchError: true, details: data });
                }
            })
    .catch((error) => {
      reject(error);
            });
});
